<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-blue-400 hover:text-blue-600" href="/companies">Companies</Link>
      <span class="text-blue-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="company.deleted_at" class="mb-6" @restore="restore"> This company has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <select-input v-model="form.region_id" :error="form.errors.region_id" class="pb-8 pr-6 w-full lg:w-1/3" label="Region">
            <option v-for="region in regions" :key="region.id" :value="region.id"> {{ region.name }}</option>
          </select-input>
          <select-input v-model="form.price_list_id" :error="form.errors.price_list_id" class="pb-8 pr-6 w-full lg:w-1/3" label="Price List">
            <option v-for="pricelist in pricelists" :key="pricelist.id" :value="pricelist.id"> {{ pricelist.name }}</option>
          </select-input>
          <div class="w-full mb-4">
            <label class="form-label"><b>Custom Discounts</b> <span class="text-xs">(applied to this company only, overriding the default pricelist discount)</span></label>
            <div class="grid grid-cols-4">
              <div v-for="discount in discounts" :key="discount.id">
                <input v-model="form.discounts" type="checkbox" :value="discount.id" />
                <span class="text-sm px-2">{{ discount.value }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="! company.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Company</button>
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Update Company</loading-button>
        </div>
      </form>
    </div>
    <!-- Teams -->
    <div class="flex items-center justify-between">
      <h2 class="mt-12 text-2xl font-bold">Teams</h2>
      <div>
        <a class="btn-blue" :href="`/teams/${company.id}/create`">Create team</a>
      </div>
    </div>
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6" colspan="2">Name</th>
        </tr>
        <tr v-for="team in company.teams" :key="team.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-blue-500" :href="`/teams/${team.id}/edit`">
              {{ team.name }}
              <icon v-if="team.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/teams/${team.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="company.teams.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No teams found.</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    TextInput,
    SelectInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    company: Object,
    discounts: Array,
    regions: Array,
    pricelists : Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name         : this.company.name,
        region_id    : this.company.region_id,
        price_list_id: this.company.price_list_id,
        discounts    : this.company.discounts.map(el => el.id),
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/companies/${this.company.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this company?')) {
        this.$inertia.delete(`/companys/${this.company.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this company?')) {
        this.$inertia.put(`/companys/${this.company.id}/restore`)
      }
    },
  },
}
</script>
